// Global site metadata — single source of truth for both the React app and
// the llms.txt generator (scripts/generate-llms.js). Keep this as plain
// CommonJS so Node can `require()` it at build time without a transpiler.

module.exports = {
  name: "Will Laws",
  tagline: "Technology Leader & Solutions Architect",
  description:
    "Technology leader who modernises platforms, strengthens governance, and builds teams that ship. Senior Solutions Architect at AWS, 3x re:Invent speaker, based in Sydney, Australia.",
  url: "https://laws.rocks",
  email: "will@laws.rocks",
  blog: {
    text: "123cloud.st",
    url: "https://www.123cloud.st",
  },
  from: "Sydney, Australia",
  social: {
    linkedin: "https://www.linkedin.com/in/lwsw/",
    github: "https://github.com/jeeshofone",
  },
  credly: "https://www.credly.com/users/william-laws.3bfa4da4/badges",
  // Start year used to compute "Years on AWS" dynamically in both the React
  // stats block and the generated llms content.
  awsStartYear: 2009,
};
